/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { CSVLink, CSVDownload } from "react-csv";

/**
 * Internal dependencies
 */
import Button from 'components/button';
import { successNotice, errorNotice } from 'state/notices/actions';
import cecSdk from 'lib/customer-ec-sdk';
import JumpingDots from 'components/jumping-dots';

const ExportConnectionButton = ({ connectionId, details, ...props }) => {
    
    const [exporting, setExport] = useState(false);
    const [exported, setExported] = useState(false);
    const [exportData, setExportData] = useState([]);

    const headers = [
      { label: "SKU", key: "sku" },
      { label: "Product Name", key: "title" },
      { label: "Tags", key: "tags" },
      { label: "Weight", key: "weight" },
      { label: "Weight Unit", key: "weight_unit" },
      { label: "Images", key: "images" }
    ];

    const exportConnection = async () => {
        setExport(true);
        try {
            let { result } = await cecSdk.connection(connectionId).export({ connectionDetails: details });

            if (result && result.error) {
                props.errorNotice(result.error);
            } else if (Array.isArray(result) && result.length > 0) {
                setExportData(result);
                setExported(true);
                props.successNotice('Exported');
            } else {
                props.errorNotice('No data returned — check connection credentials.');
            }
        } catch (error) {
            props.errorNotice('Unknown error occoured.');
            console.log(error);
        }
        setExport(false);
    };

    return (<div>
                <Button disabled={exporting} onClick={exportConnection}>
                    {exporting ? <div>Exporting <JumpingDots /></div> : 'Export'}
                </Button>
                {exported ? (
                <CSVLink disabled={exporting}
                         data={exportData} 
                         headers={headers}
                         filename="export.csv"
                         target="_blank"
                         className="card__section--export-btn">Download
                </CSVLink>) : ""}
            </div>
    );

};

export default connect(null, {
    successNotice,
    errorNotice,
})(ExportConnectionButton);
